import { render, staticRenderFns } from "./mooby.vue?vue&type=template&id=73be855c&scoped=true&"
import script from "./mooby.vue?vue&type=script&lang=js&"
export * from "./mooby.vue?vue&type=script&lang=js&"
import style0 from "./mooby.vue?vue&type=style&index=0&id=73be855c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73be855c",
  null
  
)

export default component.exports